import { useCallback, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { RowDoubleClickedEvent } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { makeStyles } from "@material-ui/core";
import { AccommodationRequestSearchItemFragment } from "@bonliva-crm/graphql";
import { DataGrid, usePolling } from "@bonliva-crm/ui";
import { useGlobalStore } from "@hooks";
import { useInitialColumnDefs } from "./use-initial-column-defs";
import { useColumnNameSelector } from "./use-column-name-selector";
import { useAccommodationRequestSearchFilters } from "../../hooks/use-accommodation-request-search-filters";
import { useAccommodationRequestTableDatasource } from "./use-accommodation-request-table-datasource";
import { AccommodationRequestTopBar } from "../accommodation-request-top-bar";
import { AccommodationRequestViewLocation } from "@bookings/BookingHospitality/locations/AccommodationRequestViewLocation";

export const AccommodationRequestTable = () => {
  const { queryInput } = useAccommodationRequestSearchFilters();
  const columnNameSelector = useColumnNameSelector();
  const gridRef = useRef<AgGridReact>(null);
  const classes = useStyles();
  const { navigation } = useGlobalStore();

  const queryInputRef = useRef<any>();

  useEffect(() => {
    queryInputRef.current = queryInput;
  }, [queryInput]);

  const colDefs = useInitialColumnDefs();

  // todo fix this
  usePolling(
    () => {
      gridRef.current?.api?.refreshInfiniteCache();
    },
    "/accommodation_requests",
    { interval: 5000, refetchOnPushState: true }
  );

  const onRowClicked = useCallback(
    ({ data, event }: RowDoubleClickedEvent<AccommodationRequestSearchItemFragment>) => {
      if (event.defaultPrevented) return;

      const target = event?.target;
      if ("tagName" in target && target?.tagName === "A") return;

      return navigation.open(
        "accommodation_request_view",
        new AccommodationRequestViewLocation({ requestId: data._id })
      );
    },
    [navigation]
  );

  const datasource = useAccommodationRequestTableDatasource({
    getGridRef: () => gridRef.current
  });

  return (
    <div className={classes.root}>
      <DataGrid
        ref={gridRef}
        columnDefs={colDefs}
        rowSelection={"multiple"}
        onRowClicked={onRowClicked}
        suppressRowClickSelection={true}
        datasource={datasource}
        rowModelType={"infinite"}
        maxBlocksInCache={1}
        cacheBlockSize={50}
        paginationPageSize={50}
        paginationPageSizeSelector={[50, 20, 10]}
        pagination={true}
        getRowId={(p) => p.data._id}
        animateRows={true}
        rowHeight={70}
        // getRowClass={(params) => {
        //
        // }}
        columnNameSelector={columnNameSelector}
        suppressCellFocus={true}
        context={{ highlightText: queryInput.text }}
        topBar={<AccommodationRequestTopBar />}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    paddingBottom: "1rem"
  }
}));
